import { render, staticRenderFns } from "./ProjectChangesTable.vue?vue&type=template&id=79118294&"
import script from "./ProjectChangesTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectChangesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports